import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { platformAPI, analyticsAPI } from '../api';
import MaestraLogo from '../components/MaestraLogo';
import LegalFooterLinks from '../components/LegalFooterLinks';
import PlatformFooter from '../components/PlatformFooter';

const LandingPage = () => {
  const navigate = useNavigate();
  document.title = 'Maestra';
  const [ptx, setPtx] = useState(null);

  useEffect(() => {
    platformAPI.getTexts().then(res => setPtx(res.data)).catch(() => {});
    analyticsAPI.track('home');
  }, []);

  // Staggered entry timings (ms) — start after the logo reveal (~1500ms)
  const delays = {
    title: '1600ms',
    subtitle: '1900ms',
    note: '2200ms',
    divider: '2500ms',
    cta: '2700ms',
    secondary: '2900ms',
    footer: '3100ms',
  };

  return (
    <div className="landing-page">
      {/* Meta tags for privacy */}
      <meta name="robots" content="noindex, nofollow" />

      <div className="landing-hero">
        <MaestraLogo size="lg" />

        {/* Generous breathing room between logo and Welcome heading */}
        <div style={{ height: '120px' }} />

        <h1
          className="landing-title landing-fade"
          data-testid="landing-title"
          style={{ animationDelay: delays.title }}
        >
          {ptx?.home_title || 'Welcome.'}
        </h1>

        <p
          className="landing-subtitle landing-fade"
          data-testid="landing-subtitle"
          style={{ whiteSpace: 'pre-line', animationDelay: delays.subtitle }}
        >
          {ptx?.home_subtitle || 'A calm space to organize your ideas, direction and decisions.\nEverything in one place — clear, simple, structured.'}
        </p>

        {(ptx?.home_note !== undefined ? ptx.home_note : true) && (
          <p
            className="landing-fade"
            data-testid="landing-note"
            style={{
              fontSize: '13px',
              color: 'var(--kahla-text-light)',
              fontStyle: 'italic',
              marginTop: '8px',
              maxWidth: '420px',
              lineHeight: 1.7,
              animationDelay: delays.note,
            }}
          >
            {ptx?.home_note || 'Take your time. Everything here is designed to support your process.'}
          </p>
        )}

        <div
          className="landing-divider landing-fade"
          style={{ animationDelay: delays.divider }}
        ></div>

        <button
          className="btn-secondary landing-fade"
          data-testid="landing-cta"
          onClick={() => navigate('/login')}
          style={{ animationDelay: delays.cta }}
        >
          {ptx?.home_cta || 'Access your workspace'}
        </button>

        <div
          className="landing-fade"
          style={{ animationDelay: delays.secondary, marginTop: '24px' }}
        >
          <div
            data-testid="landing-secondary-cta"
            onClick={() => navigate('/request-access')}
            style={{
              fontSize: '12px',
              color: 'var(--kahla-text-light)',
              cursor: 'pointer',
              opacity: 0.65,
              letterSpacing: '0.03em',
              transition: 'opacity 0.25s ease',
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = '1'}
            onMouseLeave={e => e.currentTarget.style.opacity = '0.65'}
          >
            {ptx?.home_secondary_cta || 'New here? Explore Maestra'}
          </div>
        </div>
      </div>

      <footer
        className="landing-fade"
        style={{
          padding: '28px 24px',
          textAlign: 'center',
          borderTop: '1px solid var(--kahla-border)',
          backgroundColor: 'var(--kahla-cream)',
          animationDelay: delays.footer,
        }}
      >
        <PlatformFooter />
        <LegalFooterLinks marginTop={14} />
      </footer>
    </div>
  );
};

export default LandingPage;
